import React, { Component } from 'react';


import firebase from './fire.js';
import firebaseClone from './fireClone.js';


import './Login.css';

function shallowEqual(objA: mixed, objB: mixed): boolean {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null ||
      typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

class Login extends Component {

  constructor(props){
    super(props);
    this.value = (this.props.value) ? this.props.value : null;

    this.handleLogin = this.handleLogin.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log('shouldComponentUpdate: ', nextProps, nextState);
  //   console.log('shouldComponentUpdate: ', shallowCompare(this, nextProps, nextState));
  //   return shallowCompare(this, nextProps, nextState);
  // }

  componentWillMount(){

    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        // console.log('USER SIGNED IN: ', user.uid);
        // console.log('run function');

        this.props.handleUser(user);

      } else {
        // No user is signed in.
        // console.log('NO USER SIGNED IN');
        if(!this.props.noLogin){
          this.props.handleLogOut();
        }
      }
    }.bind(this));

  }

  handleDelete(){
    this.props.handleLogOut();
  }

  handleLogin(e){
    e.preventDefault();

    var email = document.getElementById('email').value;
    var password = document.getElementById('password').value;
    let errorText = document.getElementById('error-message');

    firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
      // Handle Errors here.
      // var errorCode = error.code;
      var errorMessage = error.message;

      errorText.textContent = (errorMessage);

      errorText.classList.add('show');

      setTimeout(function () {
        errorText.classList.remove('show');

      }, 3000);
    });

  }

  handleSignUp(e) {

    e.preventDefault();

    console.log('creating new user');
    let _name = document.getElementById('create-user-name').value;
    let _email = document.getElementById('create-user-email').value;
    let _password = document.getElementById('create-user-password').value;

    console.log('email: ' + _email);

    if (_email.length < 4) {
      alert('Please enter an email address.');
      return;
    }
    if (_password.length < 4) {
      alert('Please enter a longer password.');
      return;
    }
    // Sign in with email and pass.
    // [START createwithemail]
    firebaseClone.auth().createUserWithEmailAndPassword(_email, _password)
      .then(result => {
        console.log('result: ', result.user);
        let newUser = {
          uid: result.user.uid,
          name: _name,
          email: result.user.email,
        };

        console.log('newUser:', newUser);

        this.props.handleNewUser(newUser);
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // [START_EXCLUDE]
        if (errorCode === 'auth/weak-password') {
          alert('The password is too weak.');
        } else {
          alert(errorMessage);
        }
        console.log(error);
        // [END_EXCLUDE]
      });
      // [END createwithemail]
  }


  render() {

    if(this.props.noLogin){
      return (
        <form className="login-wrapper flex-col box" onSubmit={this.handleSignUp}>

          <input required id="create-user-name" type="text" placeholder="Namn"/>
          <input required id="create-user-email" type="email" placeholder="Email"/>
          <input required id="create-user-password" type="password" placeholder="password"/>
          <input type="submit" value="Skapa konto"/>

          <span id="error-message"></span>

        </form>
      );
    }
    else {
      return (
        <form className="login-wrapper flex-col box" onSubmit={this.handleLogin}>

          <input required id="email" type="email" placeholder="Email"/>
          <input required id="password" type="password" placeholder="password"/>
          <input type="submit" value="Logga in"/>
          <span id="error-message"></span>

        </form>
      );
    }


  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js